import React from 'react';
import { useMaterialSymbols } from './MaterialSymbolsProvider';
import PagePreloader from '../PagePreloader';

/**
 * MaterialSymbolsPreloader - Menampilkan preloader sampai Material Symbols font siap
 */
const MaterialSymbolsPreloader = ({ children }) => {
  const { isReady, isLoading } = useMaterialSymbols();
  const showPreloader = isLoading || !isReady;

  return (
    <>
      <PagePreloader show={showPreloader} />
      {children}
    </>
  );
};

export default MaterialSymbolsPreloader;
